export default __webpack_public_path__ + "static/media/olumide.9e8afb65.png";